<template>
  <div class="date-picker">
    <a-date-picker
      v-if="singleDatePicker"
      style="width: 100%"
      v-bind="propsValue"
      :placeholder="singleplaceholder"
      :value="value || defaultValue"
      @change="onChange"
    />
    <a-range-picker
      v-else
      style="width: 100%"
      v-bind="propsValue"
      :placeholder="rangePlaceholder"
      :value="rangeValue || defaultValue"
      @change="onChange"
    ></a-range-picker>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      value: null,
      rangeValue: null,
    }
  },
  computed: {
    ...mapState(['lang', 'locale']),
    rangePlaceholder() {
      if (this.placeholder2) return this.placeholder2
      return this.placeholder
        ? [
            this.placeholder.slice(0, this.placeholder.length - 2) + this.$t(`form.StartTime`),
            this.placeholder.slice(0, this.placeholder.length - 2) + this.$t(`form.EndTime`),
          ]
        : null
    },
    singleplaceholder() {
      return this.placeholder ? this.placeholder : this.$t(`form.SelectTime`)
    },
    propsValue() {
      return {
        id: this.id,
        'show-time': {
          'default-value': this.singleDatePicker
            ? moment('00:00:00', 'HH:mm:ss')
            : [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
        },
        locale: this.locale?.Calendar,
        ranges: this.ranges,
        // format: this.format,
        format: 'YYYY-MM-DD HH:mm:ss',
      }
    },
    defaultValue() {
      let defaultValue = null
      if (this.singleDatePicker) {
        defaultValue = this.startTime ? moment(this.startTime) : null
      } else {
        if (this.startTime && this.endTime) {
          defaultValue = [moment(this.startTime), moment(this.endTime)]
        }
      }
      return defaultValue
    },
    ranges() {
      let ranges = {}
      ranges[this.$t(`form.Today`)] = [moment().startOf('days'), moment()]
      ranges[this.$t(`form.Yesterday`)] = [
        moment().subtract(1, 'days').startOf('days'),
        moment().subtract(1, 'days').endOf('days'),
      ]
      ranges[this.$t(`form.Last7days`)] = [moment().subtract(7, 'days'), moment()]
      ranges[this.$t(`form.Last30days`)] = [moment().subtract(30, 'days'), moment()]
      ranges[this.$t(`form.CurrentMonth`)] = [moment().startOf('month'), moment().endOf('month')]
      ranges[this.$t(`form.LastMonth`)] = [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ]
      return ranges
    },
    format() {
      let format =
        this.lang === 'zh' ? 'YYYY-MM-DD HH:mm:ss' : this.locale.Calendar.lang.dateTimeFormat
      return format
    },
  },
  props: [
    'startTime',
    'endTime',
    'placeholder',
    'placeholder2',
    'id',
    'needhms',
    'singleDatePicker',
  ],
  methods: {
    moment,
    onChange(m_value, value) {
      this.value = value
      this.rangeValue = m_value
      let data = this.singleDatePicker
        ? value
        : {
            start_time: value[0],
            end_time: value[1],
          }
      this.$emit('get_date', data)
      this.$nextTick(() => {
        this.$emit('changeList', 'speed')
      })
    },
    clear() {
      this.value = null
      this.rangeValue = null
    },
  },
}
</script>
<style scoped>
.date-input {
  width: 100%;
  background-color: #fff;
}
</style>
